import loadable from '@loadable/component'

export const EmbeddedRatings = loadable(() => import('./EmbeddedRatings'))
export const AdditionalRatings = loadable(() => import('./AdditionalRatings'))
export type { AdditionalRatingsProps } from './AdditionalRatings'
export type {
  EmbeddedRatingProps,
  EmbeddedRatingsProps
} from './EmbeddedRatings'
